import { useSelector } from 'react-redux';
import useGet from '../../hooks/Common/useGet';
import { setCachedLocationList } from '../../redux/cachedLocationsReducer';
import { RootState } from '../../redux/store';
import getLocations from '../../web_api/methods/settings/locations/getLocations';
import FruitsVegetablesCard from './FruitsVegetablesCard';
import LoadingPage from '../../layout/LoadingPage';
import { useEffect, useState } from 'react';
import useToolbarSetter from '../../hooks/Common/useToolbarSetter';
import getLFLocations from '../../web_api/methods/settings/locations/getLFLocations';
import getExternalLink, { ExternalLink } from '../../web_api/methods/externalLinks/getExternalLink';
import { demoLocationsList } from '../QueueManagement/demoAvgCashRegisterOpen';

const FruitsVegetables = () => {
  const cachedLocationsList = useSelector((state: RootState) => state.cachedLocations);
  const userList = useSelector((state: RootState) => state.userList);
  const selectedUser = useSelector((state: RootState) => state.selectedUser);
  const username = useSelector((state: RootState) => state.user.user_name);

  const isDemoUser = () => username.includes('demo');

  let selectedUserLocations: number[] = [];
  const [lfLocations, setLfLocations] = useState<number[]>([]);
  const [externalLink, setExternalLink] = useState<ExternalLink>();

  const { setToolbar } = useToolbarSetter();

  useEffect(() => {
    setToolbar('fruits-and-vegetables', 'Fruits & Vegetables');
  });

  const loadLF = async () => {
    const res = await getLFLocations();
    setLfLocations(res);
  };

  const handleExternalLink = async () => {
    const response = await getExternalLink(window.location.pathname);
    setExternalLink(response);
  };

  useEffect(() => {
    loadLF();
    handleExternalLink();
  }, []);

  const { loading } = useGet([], getLocations, setCachedLocationList);

  if (selectedUser) {
    const user = userList.list.find((user) => user.id === selectedUser.id);
    if (user) {
      selectedUserLocations = user.locations.map((location) => location.id);
    }
  }

  return (
    <div className='container'>
      {externalLink && (
        <div className='btn btn-secondary d-flex flex-row align-items-center gap-2 m-5 mb-0' style={{ justifySelf: 'end', width: 'fit-content' }} onClick={() => { window.open(externalLink.link, '_blank'); }}>Power BI <i className='bi bi-box-arrow-up-right'></i></div>
      )}
      <div className='d-flex flex-column flex-md-row'>
        <div className='d-flex flex-row flex-md-column col-12'>
          <div className='p-5 pb-0'>
            <div className='row'>
              {loading ? (
                <LoadingPage />
              ) : !isDemoUser() ? 
                cachedLocationsList &&
                cachedLocationsList.list.map((location) => {
                  if ((selectedUserLocations.length === 0 || selectedUserLocations.includes(location.id)) && lfLocations.length > 0) {
                    return <FruitsVegetablesCard key={location.id} location={location} loading={loading} lf={lfLocations.includes(location.id)} />;
                  }
                })
               : (
                demoLocationsList.map((location) => {
                  return <FruitsVegetablesCard key={location.id} location={location} loading={false} lf={true} />;
                })
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FruitsVegetables;
